import { Navigate } from "react-router";
import MainLayout from "../views/layouts/MainLayout";

import MainGuard from "./route-guard/MainGuard";
import RoleGuard from "./route-guard/RoleGuard";
// import Contacts from "../views/pages/Contacts";
import Users from "../views/pages/users";

import Contacts from "../views/pages/contacts";
import ChangePassword from "../views/pages/users/change-password";
import AccountSetting from "../views/pages/accountSetting";
import Cases from "../views/pages/cases/index";
import Prospects from "../views/pages/prospects";
import Todos from "../views/pages/todos";
import TimeEntry from "../views/pages/timeEntry";
import Sms from "../views/pages/sms";
import Payments from "../views/pages/payments";
import DocuSign from "../views/pages/docuSign";
import Case from "../views/pages/cases/Case";
import DocExplorer from "../views/pages/docExplorer";

/**
 * Routes component that conditionally renders application routes based on user authentication status.
 * @component MainRoutes
 * @author Priyanshu
 */

const MainRoutes = () => ({
  path: "/", // Base path for the main routes
  element: (
    <MainGuard>
      <MainLayout />
    </MainGuard>
  ),
  children: [
    {
      path: "/contacts",
      element: (
        <RoleGuard allowedRoles={["ADMIN", "LAWYER", "STAFF"]}>
          <Contacts />
        </RoleGuard>
      ),
    },
    {
      path: "/payments",
      element: (
        <RoleGuard allowedRoles={["ADMIN", "LAWYER", "STAFF"]}>
          <Payments />
        </RoleGuard>
      ),
    },
    {
      path: "/docusign-waiting",
      element: (
        <RoleGuard allowedRoles={["ADMIN", "LAWYER", "STAFF"]}>
          <DocuSign />
        </RoleGuard>
      ),
    },
    {
      path: "/todo",
      element: (
        <RoleGuard allowedRoles={["ADMIN", "LAWYER", "STAFF"]}>
          <Todos />
        </RoleGuard>
      ),
    },
    {
      path: "/cases",
      element: (
        <RoleGuard allowedRoles={["ADMIN", "LAWYER", "STAFF"]}>
          <Cases />
        </RoleGuard>
      ),
    },
    {
      path: "/cases/:id",
      element: (
        <RoleGuard allowedRoles={["ADMIN", "LAWYER", "STAFF"]}>
          <Case />
        </RoleGuard>
      ),
    },
    {
      path: "/users",
      element: (
        <RoleGuard allowedRoles={["ADMIN"]}>
          <Users />
        </RoleGuard>
      ),
    },
    {
      path: "/prospects",
      element: (
        <RoleGuard allowedRoles={["ADMIN", "LAWYER", "STAFF"]}>
          <Prospects />
        </RoleGuard>
      ),
    },
    {
      path: "/sms",
      element: (
        <RoleGuard allowedRoles={["ADMIN", "LAWYER", "STAFF"]}>
          <Sms />
        </RoleGuard>
      ),
    },
    {
      path: "/doc-explorer",
      element: (
        <RoleGuard allowedRoles={["ADMIN", "LAWYER", "STAFF"]}>
          <DocExplorer />
        </RoleGuard>
      ),
    },
    {
      path: "/change-password",
      element: <ChangePassword />,
    },
    {
      path: "/settings",
      element: (
        <RoleGuard allowedRoles={["ADMIN", "LAWYER", "STAFF"]}>
          <AccountSetting />
        </RoleGuard>
      ),
    },
    {
      path: "/time-entry",
      element: (
        <RoleGuard allowedRoles={["ADMIN", "LAWYER", "STAFF"]}>
          <TimeEntry />
        </RoleGuard>
      ),
    },
    {
      path: "*",
      element: <Navigate to={"/cases"} />,
    },
  ],
});

export default MainRoutes;
